import type { VehicleReview } from '../api/types'

/**
 * The review section's heading and subheading.
 *
 * These live together and away from the component on purpose: the heading names the publisher, so
 * it is half of the attribution the API's contract requires. Changing one without the other is how
 * a review ends up rendered under a heading that credits nobody.
 */
export function reviewSectionTitle(review: VehicleReview): string {
  return `Beoordeling door ${review.source}`
}

export function reviewSectionSubtitle(review: VehicleReview): string {
  // The publisher's own tagline, and nothing more: the heading directly above already says
  // "Beoordeling door Autozine", so repeating it here would read as a rendering fault. Any other
  // publisher gets a neutral line rather than a slogan we were never given.
  return review.source === 'Autozine'
    ? 'Hét Automagazine op internet'
    : `Onafhankelijke beoordeling van dit model door ${review.source}`
}
